var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2507 22.4168V23.5002C19.2507 25.2951 17.7956 26.7502 16.0007 26.7502C14.2057 26.7502 12.7507 25.2951 12.7507 23.5002V22.4168M19.2507 22.4168H12.7507M19.2507 22.4168H23.1404C23.5548 22.4168 23.763 22.4168 23.9308 22.3602C24.2513 22.2521 24.5021 22.0004 24.6102 21.6799C24.667 21.5115 24.667 21.3026 24.667 20.8849C24.667 20.7021 24.6668 20.6108 24.6525 20.5236C24.6255 20.359 24.5616 20.2029 24.4643 20.0673C24.4128 19.9957 24.3474 19.9303 24.2186 19.8015L23.7966 19.3795C23.6605 19.2433 23.584 19.0586 23.584 18.8661V14.8335C23.584 10.6453 20.1888 7.25015 16.0007 7.25016C11.8125 7.25017 8.41732 10.6453 8.41732 14.8335V18.8661C8.41732 19.0587 8.34067 19.2433 8.20451 19.3795L7.78255 19.8014C7.65332 19.9307 7.58861 19.9956 7.53711 20.0673C7.43978 20.2029 7.37531 20.359 7.34828 20.5236C7.33398 20.6108 7.33398 20.7022 7.33398 20.885C7.33398 21.3026 7.33398 21.5114 7.39081 21.6799C7.49892 22.0004 7.75085 22.2521 8.07137 22.3602C8.23917 22.4168 8.44658 22.4168 8.861 22.4168H12.7507M22.5208 6.18164C24.0149 7.30756 25.192 8.80124 25.9374 10.5172M9.48111 6.18164C7.98696 7.30756 6.80987 8.80124 6.06445 10.5172",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOn);
export default __webpack_public_path__ + "static/media/bell-on.0ad63a3971d0955864d89121a681966b.svg";
export { ForwardRef as ReactComponent };